import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./DepotsUIHelpers";

const DepotUIContext = createContext();

export function useDepotUIContext() {
  return useContext(DepotUIContext);
}

export const DepotUIConsumer = DepotUIContext.Consumer;

export function DepotUIProvider({ productsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    // openEditProductPage: productsUIEvents.openEditProductPage,
    // openDeleteProductDialog: productsUIEvents.openDeleteProductDialog,
    // openDeleteProductsDialog: productsUIEvents.openDeleteProductsDialog,
    // openFetchProductsDialog: productsUIEvents.openFetchProductsDialog,
    // openUpdateProductsStatusDialog: productsUIEvents.openUpdateProductsStatusDialog,
  };

  return (
    <DepotUIContext.Provider value={value}>{children}</DepotUIContext.Provider>
  );
}
